import React from 'react'

function NumericalDifferentiation() {
    return (

        
        <div className='entire_page'>
            <div className='super_header'>
                <h2>
                    This is Numerical Differentiation
                </h2>
            </div>

        </div>
        
    )
}

export default NumericalDifferentiation